import urlParams from '@/assets/script/urlParams'
import store from '@/store'

let source, campaign, media
if (urlParams.utm_source) {
  source = urlParams.utm_source
  store.commit({
    type: 'updateUTM',
    key: 'utm_source',
    value: urlParams.utm_source,
  })
} else if (store.state.utm.utm_source) {
  source = store.state.utm.utm_source
}

if (urlParams.utm_campaign) {
  campaign = urlParams.utm_campaign
  store.commit({
    type: 'updateUTM',
    key: 'utm_campaign',
    value: urlParams.utm_campaign,
  })
} else if (store.state.utm.utm_campaign) {
  source = store.state.utm.utm_campaign
}

if (urlParams.utm_media) {
  media = urlParams.utm_media
  store.commit({
    type: 'updateUTM',
    key: 'utm_media',
    value: urlParams.utm_media,
  })
} else if (store.state.utm.utm_media) {
  source = store.state.utm.utm_media
}

export default { source, campaign, media }
